"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.communicationMacroListResponseSchema = exports.communicationMacroSchema = exports.communicationMacroContentSchema = exports.communicationMacroIdSchema = void 0;
const zod_1 = require("zod");
exports.communicationMacroIdSchema = zod_1.z.string().uuid();
exports.communicationMacroContentSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(1).max(120),
    body: zod_1.z.string().trim().min(1).max(20_000),
});
exports.communicationMacroSchema = exports.communicationMacroContentSchema.extend({
    id: exports.communicationMacroIdSchema,
    businessId: zod_1.z.string().uuid(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
});
exports.communicationMacroListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.communicationMacroSchema),
});
//# sourceMappingURL=communication-macro.js.map